export default "__VITE_ASSET__f7fdf808__"